/**
 * MyPage API 서비스
 */
import {apiClient} from '../../../../core/api/client';
import {
    MyPageInfoResponse,
    MyPageAccountUpdateResponse,
    MyPageSettlementUpdateRequest,
    AccountDeletionRequest,
    AccountDeletionResponse,
    RemainingDepositResponse,
    WeeklyPerformanceCheckResponse,
    DailyDeductionCheckResponse
} from '../types/myPage';

const BASE_PATH = '/api/v1/mob/mypage';

/**
 * MyPage 정보 조회
 * GET /api/v1/mob/mypage/info
 * riderId, suppId는 토큰에 포함되어 있으므로 파라미터에서 제외
 */
export const getMyPageInfo = async (): Promise<MyPageInfoResponse> => {
    const response = await apiClient.get<MyPageInfoResponse>(
        `${BASE_PATH}/info`
    );
    return response.data;
};

/**
 * MyPage 정산 정보 업데이트
 * POST /api/v1/mob/mypage/account
 */
export const updateMyPageSettlement = async (
    data: MyPageSettlementUpdateRequest
): Promise<MyPageAccountUpdateResponse> => {
    const response = await apiClient.post<MyPageAccountUpdateResponse>(
        `${BASE_PATH}/account`,
        data
    );
    return response.data;
};

/**
 * 계정 탈퇴 요청
 * POST /api/v1/mob/mypage/account-deletion
 */
export const requestAccountDeletion = async (
    data: AccountDeletionRequest
): Promise<AccountDeletionResponse> => {
    const response = await apiClient.post<AccountDeletionResponse>(
        `${BASE_PATH}/account-deletion`,
        data
    );
    return response.data;
};

/**
 * 잔여 예치금 조회
 * GET /api/v1/mob/mypage/remaining-deposit
 */
export const getRemainingDeposit = async (): Promise<RemainingDepositResponse> => {
    const response = await apiClient.get<RemainingDepositResponse>(
        `${BASE_PATH}/remaining-deposit`
    );
    return response.data;
};

/**
 * 주정산 대상 수행내역 확인
 * GET /api/v1/mob/mypage/weekly-performance-check
 */
export const checkWeeklyPerformance = async (): Promise<WeeklyPerformanceCheckResponse> => {
    const response = await apiClient.get<WeeklyPerformanceCheckResponse>(
        `${BASE_PATH}/weekly-performance-check`
    );
    return response.data;
};

/**
 * 잔여 일차감 내역 확인
 * GET /api/v1/mob/mypage/daily-deduction-check
 */
export const checkDailyDeductions = async (): Promise<DailyDeductionCheckResponse> => {
    const response = await apiClient.get<DailyDeductionCheckResponse>(
        `${BASE_PATH}/daily-deduction-check`
    );
    return response.data;
};
